export default "__VITE_ASSET__912ebc90__"